class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
          .then((response) => response.text())
          .then((responseText) => {
            Shopify.getCart((cart) => {window.sharedFunctions?.updateSidebarCart(cart)});
          });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('coupon-code', CouponCode);
/* === Calmosis "Offers & coupons" widget (theme-native) === */
(function(){
  if (window.__calOffersInit) return;
  window.__calOffersInit = true;

  function calApply(code, btn){
    if (!code) return;
    var wrap = btn.closest('[data-cal-offers]');
    var msg = wrap ? wrap.querySelector('[data-cal-msg]') : null;
    var label = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', label);
    btn.disabled = true; btn.textContent = '...';
    fetch('/discount/' + encodeURIComponent(code), { headers: { 'Accept': 'text/html' } })
      .then(function(r){ return r.text(); })
      .then(function(){
        try { localStorage.setItem('storedDiscount', code); } catch(e){}
        if (window.Shopify && Shopify.getCart){
          Shopify.getCart(function(cart){
            if (window.sharedFunctions && window.sharedFunctions.updateSidebarCart) window.sharedFunctions.updateSidebarCart(cart);
          });
        }
        if (msg){ msg.hidden = false; msg.textContent = 'Code "' + code + '" applied — your discount shows at checkout.'; }
        btn.textContent = 'Applied';
        setTimeout(function(){ btn.textContent = label; btn.disabled = false; }, 2000);
      })
      .catch(function(){
        if (msg){ msg.hidden = false; msg.textContent = 'Could not apply that code. Please try again.'; }
        btn.textContent = label; btn.disabled = false;
      });
  }

  document.addEventListener('click', function(e){
    var toggle = e.target.closest('[data-cal-offers-toggle]');
    if (toggle){
      var wrap = toggle.closest('[data-cal-offers]');
      var panel = wrap.querySelector('.cal-offers__panel');
      var open = !panel.hidden;
      panel.hidden = open;
      toggle.setAttribute('aria-expanded', String(!open));
      wrap.classList.toggle('is-open', !open);
      return;
    }
    var applyBtn = e.target.closest('[data-cal-apply]');
    if (applyBtn){ calApply(applyBtn.getAttribute('data-cal-apply'), applyBtn); return; }
    var manualBtn = e.target.closest('[data-cal-apply-manual]');
    if (manualBtn){
      var wrap2 = manualBtn.closest('[data-cal-offers]');
      var input = wrap2.querySelector('[data-cal-code]');
      var code = input && input.value ? input.value.trim() : '';
      if (code) calApply(code, manualBtn);
      return;
    }
  });
})();

/* === Calmosis: "Order special instructions" row (moved below Offers & coupons) === */
(function(){
  if (window.__calNoteInit) return;
  window.__calNoteInit = true;
  document.addEventListener('click', function(e){
    var n = e.target.closest('[data-cal-note]');
    if (!n) return;
    var p = document.getElementById('popup-tool-note');
    if (p) p.classList.add('show');
    var pc = document.querySelector('.previewCart');
    if (pc) pc.classList.add('active-tool');
  });
})();
